/* src/app/ship/ship.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.shipping,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.shipping {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  font-size: 1rem;
}
.shipping .ship-page-header {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding-bottom: 0;
}
@media screen and (min-width: 48rem) {
  .shipping .ship-page-header .ship-page-header-item {
    width: auto;
    min-width: 23.5375rem;
  }
}
.shipping .ship-page-header .required-field-indicator {
  color: #d50000;
  margin: 1.25rem 0;
  font-size: 0.875rem;
  font-style: italic;
  line-height: 1;
}
.shipping .ship-page-header .required-field-indicator::before {
  content: "*";
  color: #d50000;
  margin-right: 0.25em;
}
.shipping .shipping-content .ship-sections {
  counter-reset: ship-section-counter;
}
@media screen and (min-width: 48rem) {
  .shipping .shipping-content .ship-sections .ship-section {
    width: auto;
  }
}
.shipping .shipping-content .ship-sections .ship-section .ship-section-item:not(.sub-section):not(.hide) {
  position: relative;
}
.shipping .shipping-content .ship-sections .ship-section .ship-section-item:not(.sub-section):not(.hide):before {
  content: counter(ship-section-counter) ".";
  counter-increment: ship-section-counter;
  position: absolute;
  top: 0.9em;
  left: 1.25em;
  font-size: 1.125em;
  font-weight: 700;
}
@media screen and (min-width: 48rem) {
  .shipping .shipping-content .ship-sections .ship-section .ship-section-item:not(.sub-section):not(.hide):before {
    top: 6.5px;
    left: 0;
  }
}
.shipping .shipping-content .ship-sections .ship-section .ship-section-item:not(.sub-section):not(.hide) ::ng-deep .form-section-title {
  padding-left: 1em;
}
.shipping .ship-sections-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .shipping .ship-sections-wrapper {
    flex-direction: row;
  }
}
.shipping .ship-sections {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  z-index: 2;
  flex: 1;
  gap: 2rem;
  padding: 0 1rem;
}
@media screen and (min-width: 48rem) {
  .shipping .ship-sections {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 2rem;
  }
}
.shipping .ship-sections .ship-section {
  width: 100%;
  flex: 1;
}
@media screen and (min-width: 48rem) {
  .shipping .ship-sections .ship-section {
    width: auto;
    min-width: 20.875rem;
  }
}
@media screen and (min-width: 48rem) {
  .shipping .ship-sections .ship-section:last-of-type {
    margin-left: auto;
  }
}
.shipping .ship-sections .ship-section .ship-section-item {
  display: flex;
}
.shipping .ship-sections .ship-section .ship-section-item.cost-estimator-wrapper {
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  max-width: 21.5rem;
  margin: 0 auto 2.5rem;
}
@media screen and (min-width: 48rem) {
  .shipping .ship-sections .ship-section .ship-section-item.cost-estimator-wrapper {
    margin: 0 0 2.5rem auto;
  }
}
@media screen and (min-width: 48rem) and (max-width: 64rem) {
  .shipping .ship-sections .ship-section .ship-section-item.cost-estimator-wrapper {
    min-width: 21.5rem;
    max-width: 50%;
  }
}
.shipping .ship-sections .ship-section .ship-section-item.cost-estimator-wrapper .confirm-shipment .mat-mdc-raised-button {
  width: 100%;
}
.shipping .ship-sidebar {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  will-change: min-height;
}
@media screen and (min-width: 48rem) {
  .shipping .ship-sidebar {
    width: 21.3125em;
    flex-shrink: 0;
    flex-grow: 0;
  }
}
.shipping .ship-sidebar .sticky {
  position: sticky;
  top: 20px;
}
.shipping .ship-sidebar .sticky::before,
.shipping .ship-sidebar .sticky::after {
  content: "";
  display: table;
}
.shipping .ship-sidebar .sidebar__inner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 0 1.5em 1.5em 1.5em;
  transform: translate3d(0, 0, 0);
  will-change: position, transform;
}
@media only screen and (max-width: 21.5rem) {
  .shipping .ship-sidebar .sidebar__inner {
    position: relative !important;
    transform: translate3d(0, 0, 0) !important;
    left: 0 !important;
  }
}
@media screen and (min-width: 48rem) {
  .shipping .ship-sidebar .sidebar__inner {
    flex-shrink: 0;
    flex-grow: 0;
    width: 18.75em;
    padding: 0;
  }
}
.shipping .cost-estimate {
  border: solid thin #d9d9d6;
  box-shadow: 0 1px 1px 0 rgba(217, 217, 214, 0.5);
  border-radius: 3px;
  padding: 1em 1.25em 1.25em 1.25em;
}
.shipping .cost-estimate .form-section-header {
  margin-bottom: 0.625em;
}
.shipping .cost-estimate .estimate-items {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
.shipping .cost-estimate .estimate-items .estimate-item {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  line-height: 2;
  font-size: 0.8125em;
}
.shipping .cost-estimate .estimate-items .estimate-item.total {
  font-weight: 700;
}
.shipping .cost-estimate .estimate-items .estimate-item .key {
  flex: 1.8;
}
.shipping .cost-estimate .estimate-items .estimate-item .value {
  flex: 1;
  text-align: right;
}
.shipping .cost-estimate .form-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.25em;
}
.shipping .cost-estimate .form-actions .form-action {
  flex: 1;
}
.shipping .cost-estimate .form-actions .form-action:nth-child(odd) {
  margin-right: 0.75em;
}
.shipping .cost-estimate .form-actions .form-action:nth-child(even) {
  margin-left: 0.75em;
}
.shipping .cost-estimate .form-actions .mat-mdc-raised-button {
  font-size: 0.8125em;
  height: 2.6875rem;
  width: 129px;
  padding: 0 1.375rem;
}
.shipping .cost-estimate .footnotes {
  margin-top: 1em;
}
.shipping .cost-estimate .footnotes .footnote {
  font-size: 0.625em;
  line-height: 1.6;
  margin-bottom: 1em;
}
.shipping .cost-estimate .footnotes .footnote::before {
  content: "*";
}
.shipping .terms-notice {
  font-size: 0.625em;
  line-height: 1.6;
  position: relative;
  padding: 0 0 0 2.5em;
  margin: 0.75rem auto 2em;
  width: 80%;
}
.shipping .terms-notice::before {
  content: "\e88f";
  font-family: "Material Icons";
  font-size: 2em;
  position: absolute;
  top: 0;
  left: 0;
}
.shipping .shipment-cost {
  font-size: 2em;
}
.shipping ::ng-deep .ups-form {
  width: 100%;
}
.shipping ::ng-deep .ups-form > .form-body {
  width: 100%;
  padding: 0 1.5em 1.5em 1.5em;
}
@media screen and (min-width: 48rem) {
  .shipping ::ng-deep .ups-form > .form-body {
    padding: 0 0 0.625em 0;
  }
}
.shipping ::ng-deep .ups-form > .form-body .ship-section:not(.cost-estimate) .form-section-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25em;
}
@media screen and (max-width: 33.5375rem) {
  .shipping ::ng-deep .ups-form > .form-body .ship-section:not(.cost-estimate) .form-section-header {
    height: 3.5625em;
    background-color: #f4f4f4;
    margin: 0 -1.5em 2em -1.5em;
    padding: 0 1.5em;
  }
}
.shipping ::ng-deep .ups-form > .form-body .mat-mdc-checkbox,
.shipping ::ng-deep .ups-form > .form-body .mdc-label,
.shipping ::ng-deep .ups-form > .form-body .mat-radio-label-content {
  font-size: 0.75rem;
}
.shipping .ups-form > .form-body {
  padding: 0;
  justify-content: space-between;
  width: 100%;
}
.shipping .ups-form .form-body {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .shipping .ups-form .form-body {
    flex-direction: row;
    justify-content: space-between;
  }
}
.shipping .ups-form .form-footer {
  padding: 2rem 0;
}
@media screen and (min-width: 48rem) {
  .shipping .ups-form .form-footer {
    width: 66.6666666667%;
  }
}
.shipping .ups-form .form-actions {
  position: relative;
}
.shipping .forbidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  overflow: hidden;
  background-color: rgba(20, 19, 0, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.shipping .forbidden .message {
  font-size: 2.5em;
  color: white;
  margin-top: 30%;
  padding: 1em;
  border: solid thin white;
}
.shipping .notifications .notification {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border: solid thin #e8e8e6;
  border-radius: 3px;
  padding: 1.25rem 1.25rem 1.25rem 0.90625rem;
  font-size: 0.75rem;
  margin-bottom: 2em;
  line-height: 1.5;
}
.shipping .notifications .notification::before {
  margin-right: 0.78125rem;
  width: 1.375rem;
  height: 1.375rem;
  zoom: 1.5;
}
.shipping .notifications .notification.alert {
  color: #d50000;
  border-color: #d50000;
}
.shipping .notifications .notification.alert::before {
  content: url("./media/alert.svg");
}
.shipping .notifications .notification.alert h5,
.shipping .notifications .notification.alert h6 {
  color: #d50000;
}
.shipping .notifications .notification .notification-content {
  font-size: 0.75rem;
  width: 100%;
}
.shipping .notifications .notification .notification-content h5,
.shipping .notifications .notification .notification-content h6,
.shipping .notifications .notification .notification-content .mat-mdc-checkbox,
.shipping .notifications .notification .notification-content p {
  font-size: 1em;
}
.shipping .notifications .notification .notification-content h5,
.shipping .notifications .notification .notification-content h6 {
  margin-top: 0;
}
.shipping .notifications .notification .notification-content p {
  margin-bottom: 0;
}
.shipping .notifications .notification .notification-content ::ng-deep .mat-mdc-checkbox .mdc-label {
  line-height: 18px;
  color: #d50000;
}
.shipping .notifications .notification .mat-mdc-form-field-error {
  margin-top: 1em;
}
.shipping .notifications .residential-verification p,
.shipping .notifications .reroute p {
  margin-top: 1em;
}
.shipping .notifications p {
  font-size: 0.75rem;
}
::ng-deep p {
  font-size: 0.8125em;
}
@media screen and (min-width: 48rem) {
  ::ng-deep .ups-form .form-section-header {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
  }
}
::ng-deep .ups-form .form-section-header .form-section-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-left: 0;
}
::ng-deep .ups-form .form-section-header .form-section-actions .form-section-action .mat-mdc-button,
::ng-deep .ups-form .form-section-header .form-section-actions .form-section-action .mat-mdc-raised-button,
::ng-deep .ups-form .form-section-header .form-section-actions .form-section-action.mat-button,
::ng-deep .ups-form .form-section-header .form-section-actions .form-section-action.mat-raised-button {
  min-width: 8em;
}
@media screen and (min-width: 48rem) {
  ::ng-deep .ups-form .form-section-header .form-section-actions .form-section-action .mat-mdc-button,
  ::ng-deep .ups-form .form-section-header .form-section-actions .form-section-action .mat-mdc-raised-button,
  ::ng-deep .ups-form .form-section-header .form-section-actions .form-section-action.mat-button,
  ::ng-deep .ups-form .form-section-header .form-section-actions .form-section-action.mat-raised-button {
    width: auto;
  }
}
.dd-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-around;
  row-gap: 1em;
  width: 100%;
  padding: 1.4375rem;
  background-color: #C2E3E2;
}
@media screen and (min-width: 48rem) {
  .dd-banner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    justify-content: space-around;
  }
}
.dd-banner .dd-logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5625em;
}
.dd-banner .dd-logo .dd-titles {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  font-family: "Roboto Flex", sans-serif;
  font-weight: 700;
  color: #595555;
  line-height: 1.35;
  white-space: nowrap;
}
.dd-banner .dd-logo .dd-titles .dd-title1,
.dd-banner .dd-logo .dd-titles .dd-title2 {
  font-size: 0.9em;
}
.dd-banner .dd-logo .dd-titles .dd-title3 {
  font-size: 0.75em;
  line-height: 1.55;
}
.dd-banner .dd-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  row-gap: 1em;
}
.dd-banner .dd-content .dd-description {
  color: #121212;
  font-size: 1em;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  padding: 0 1em;
  max-width: 36.9375rem;
}
@media screen and (min-width: 48rem) {
  .dd-banner .dd-content .dd-description {
    font-size: 1.25em;
    text-align: left;
  }
}
.dd-banner .dd-content .cta {
  padding: 0.46875rem 2.09375rem;
  font-size: 1.125em;
  font-weight: 500;
  height: 1.96875rem;
}
.dd-insured-value-cap {
  display: block;
  font-size: 0.6em;
  line-height: 1.5;
  padding: 0.5rem 0 1rem 1.75rem;
}
/*# sourceMappingURL=ship.component.css.map */
